module.exports = __webpack_public_path__ + "static/media/3DPPA9.1637e3d3.jpg";